import { useIntl } from "react-intl";
import { MultiSelect } from "primereact/multiselect";
import { useState } from "react";

const MultiselectDropdownForm = (props: any) => {
  const [selectedValues, setSelectedValues] = useState(
    props.SelectedValues ? props.SelectedValues : null
  );
  const intl = useIntl();

  const onControlChange = (e: any) => {
    setSelectedValues(e.value);

    if (props.SuscribedChange) props.SuscribedChange(e.value);
  };

  return (
    <>
      <MultiSelect
        value={selectedValues}
        options={props.Options}
        onChange={(e) => onControlChange(e)}
        optionLabel={`${props.OptionLabel ? props.OptionLabel : "name"}`}
        placeholder={intl.formatMessage({ id: props.Placeholder })}
        display="chip"
        appendTo={"self"}
        className={"w-100"}
      />
    </>
  );
};

export default MultiselectDropdownForm;
